// GENERATED by scripts/build-icons.mjs from icons/crosshair.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Crosshair = createIcon('crosshair', [
  ['circle', { cx: "12", cy: "12", r: "10" }],
  ['line', { x1: "22", x2: "18", y1: "12", y2: "12" }],
  ['line', { x1: "6", x2: "2", y1: "12", y2: "12" }],
  ['line', { x1: "12", x2: "12", y1: "6", y2: "2" }],
  ['line', { x1: "12", x2: "12", y1: "22", y2: "18" }],
])
